import { useSelector, useDispatch } from 'react-redux';
import FJMobileFooterModal from './FJMobileFooterModal';
import { setMobileFooterModalData } from '../../../redux/slices/FJSliceModals';
import FJActionTextToImage from '../../../redux/action/FJActionTextToImage';
import { useCallback } from 'react';
import { setSliceRatio, setSliceStyle } from '../../../redux/slices/FJSliceTextToImage';

const FJMobileFooterModalContainer = () => {
    const dispatch = useDispatch();
    const mobileFooterModalData = useSelector(state => state.modals.mobileFooterModalData);
    const curStyle = useSelector(state => state.textToImage.curStyle);
    const styleList = useSelector(state => state.textToImage.styleList);
    const curModel = useSelector(state => state.textToImage.curModel);
    const curRatio = useSelector(state => state.textToImage.curRatio);
    const generateNumber = useSelector(state => state.textToImage.generateNumber);

    const onChangeGenerateNumber = useCallback(
        value => {
            dispatch(FJActionTextToImage.changeGenerateNumberAction(value));
        },
        [dispatch],
    );
    const onChangeRatio = useCallback(
        ratio => {
            dispatch(setSliceRatio(ratio.name));
        },
        [dispatch],
    );

    const onChangeModel = useCallback(
        value => {
            dispatch(FJActionTextToImage.changeModelAction(value.value));
        },
        [dispatch],
    );
    const onChangeStyle = useCallback(
        style => {
            dispatch(setSliceStyle(style));
        },
        [dispatch],
    );
    const onClose = () => {
        dispatch(setMobileFooterModalData({ ...mobileFooterModalData, display: false }));
    };
    const aiOptimizing = useCallback(() => {
        dispatch(FJActionTextToImage.aiOptimizingAction());
    }, [dispatch]);
    const useImageAsPrompt = file => {
        dispatch(FJActionTextToImage.useImageAsPromptAction(file));
    };
    return (
        <FJMobileFooterModal
            onClose={onClose}
            mobileFooterModalData={mobileFooterModalData}
            curModel={curModel}
            onChangeModel={onChangeModel}
            curStyle={curStyle}
            onChangeStyle={onChangeStyle}
            styleList={styleList}
            curRatio={curRatio}
            onChangeRatio={onChangeRatio}
            generateNumber={generateNumber}
            onChangeGenerateNumber={onChangeGenerateNumber}
            aiOptimizing={aiOptimizing}
            useImageAsPrompt={useImageAsPrompt}
        />
    );
};
export default FJMobileFooterModalContainer;
